// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 47 ? "53c1eb4a" : chunkId) + "." + {"47":"d67f8d7ae4f8e720","209":"a6858b9608dd5e7c","535":"578186583a563790"}[chunkId] + ".js";
};